module.exports = __webpack_public_path__ + "97c91cf7170910bfac62b35e2a1e7eea.png";